import React, { FC, useCallback } from 'react';

import { TagPlaceholder } from './components';

import { SamoletSelectProps } from './types';

import { Select as StyledSelect, Action } from './styled';

export const BaseSelect: FC<SamoletSelectProps> = ({
  onChange,
  additionalField,
  onAdditionalFieldClick,
  maxTagPlaceholderGetLabelText,
  hasError,
  fullWidth,
  ...props
}) => {
  const handleClear = useCallback(() => onChange && onChange([], []), [onChange]);
  const maxTagPlaceholder = useCallback(
    selectedValues => (
      <TagPlaceholder
        size={props.size}
        count={selectedValues.length}
        getLabelText={maxTagPlaceholderGetLabelText}
        onClose={handleClear}
      />
    ),
    [handleClear, props.size, maxTagPlaceholderGetLabelText],
  );

  const additionalFieldRendered =
    additionalField && onAdditionalFieldClick ? (
      <Action onClick={onAdditionalFieldClick}>{additionalField.label}</Action>
    ) : null;

  // TODO: remove any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const defaultDropdownRender = (menu: any) => {
    return (
      <div>
        {additionalFieldRendered}
        {menu}
      </div>
    );
  };

  // TODO: remove any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const defaultGetPopupContainer = (trigger: any) => {
    return trigger.parentElement || document.body;
  };

  return (
    <StyledSelect
      maxTagCount={0}
      maxTagPlaceholder={maxTagPlaceholder}
      filterOption={false}
      optionFilterProp='label'
      popupClassName='dropDownRender'
      dropdownRender={defaultDropdownRender}
      getPopupContainer={defaultGetPopupContainer}
      onChange={onChange}
      $hasError={Boolean(hasError)}
      $fullWidth={fullWidth}
      {...props}
    />
  );
};
